import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "flex flex-col sm:flex-row flex-wrap gap-y-6" }
const _hoisted_2 = { class: "text-black-lp-300 text-12px xxl:text-14px" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Deskripsi ", -1)
const _hoisted_4 = { class: "my-1 font-normal w-8/12 capitalize" }
const _hoisted_5 = { class: "flex flex-col sm:flex-row flex-wrap gap-y-6" }
const _hoisted_6 = { class: "text-black-lp-300 text-12px xxl:text-14px" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Tanggal Dibuat ", -1)
const _hoisted_8 = { class: "my-1 font-normal" }
const _hoisted_9 = { class: "text-gray-lp-500" }
const _hoisted_10 = { class: "text-black-lp-300 text-12px xxl:text-14px" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Terakhir Diperbarui ", -1)
const _hoisted_12 = { class: "my-1 font-normal" }
const _hoisted_13 = { class: "text-gray-lp-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_ChipsV2 = _resolveComponent("ChipsV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    onBack: _ctx.goBack,
    loading: _ctx.isLoading,
    error: _ctx.isError,
    errorType: _ctx.errorCause,
    onTryAgain: _ctx.fetchDetail,
    title: "RSTHQ Penalty"
  }, _createSlots({
    "sub-data": _withCtx(() => [
      _createVNode(_component_DataWrapper, { label: "Status Konfigurasi Biaya" }, {
        default: _withCtx(() => [
          _createVNode(_component_ChipsV2, {
            label: _ctx.dataDetail.configurablePriceStatus
          }, null, 8, ["label"])
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode("div", _hoisted_8, _toDisplayString(_ctx.createdAt), 1),
        _createVNode("div", _hoisted_9, _toDisplayString(_ctx.dataDetail.configurablePriceCreatedBy), 1)
      ]),
      _createVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode("div", _hoisted_12, _toDisplayString(_ctx.updatedAt), 1),
        _createVNode("div", _hoisted_13, _toDisplayString(_ctx.dataDetail.configurablePriceUpdatedBy), 1)
      ]),
      (_ctx.isEditAble)
        ? (_openBlock(), _createBlock(_component_LpButton, {
            key: 0,
            customClass: "px-1 sm:px-12 py-2.5 text-red-lp-100",
            outline: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goEdit(_ctx.$route.params.id))),
            title: "Ubah"
          }))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (!_ctx.isLoading)
      ? {
          name: "data",
          fn: _withCtx(() => [
            _createVNode("div", _hoisted_1, [
              _createVNode(_component_DataWrapper, {
                label: "ID Konfigurasi",
                value: _ctx.dataDetail.configurablePriceId,
                class: "w-12/12 sm:w-6/12"
              }, null, 8, ["value"]),
              _createVNode(_component_DataWrapper, {
                label: "Nama Konfigurasi Biaya",
                value: _ctx.dataDetail.configurablePriceName,
                class: "w-12/12 sm:w-6/12"
              }, null, 8, ["value"])
            ]),
            _createVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode("div", _hoisted_4, _toDisplayString(_ctx.dataDetail.configurablePriceDescription), 1)
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_DataWrapper, {
                label: "Tipe Tarif",
                value: _ctx.dataDetail.configurableRtshqPenalty.crpRateType.name,
                class: "w-12/12 sm:w-6/12"
              }, null, 8, ["value"]),
              _createVNode(_component_DataWrapper, {
                label: "Persentase Denda Penalti",
                value: _ctx.dataDetail.configurableRtshqPenalty.crpPercentage + '%',
                class: "w-12/12 sm:w-6/12"
              }, null, 8, ["value"])
            ])
          ])
        }
      : undefined
  ]), 1032, ["onBack", "loading", "error", "errorType", "onTryAgain"]))
}